import { FC } from "react";
import { useTranslation } from "react-i18next";
import { SubMenuItem } from "src/constants/modules";
import MenuBannerCard from "../components/MenuBannerCard";
import LanguageSwitch from "src/Modules/MainMenu/components/LanguageSwitch/LanguageSwitch";

const SectionTitle: FC<{ title: string }> = ({ title }) => {
  return (
    <div className="flex items-center gap-2 px-1">
      <span className="text-font-subtle text-sm font-semibold">{title}</span>
      <div className="flex-1 h-px bg-border-default" />
    </div>
  );
};

const ModulesMenuMob: FC<{ items: SubMenuItem[]; activeKey: string; onClick: (key: string) => void }> = ({ items, activeKey, onClick }) => {
  const { t } = useTranslation();

  const mainItems = items.filter((i) => i.underMenu === "Main");
  const userItems = items.filter((i) => i.underMenu === "User");

  return (
    <div className="flex flex-col gap-4 p-4">
      {mainItems.length > 0 && (
        <div className="flex flex-col gap-2">
          <SectionTitle title={t("Menu.mainMenu")} />
          {mainItems.map((item) => (
            <MenuBannerCard key={item.key} item={item} isselected={activeKey === item.key} onClick={() => onClick(item.key)} />
          ))}
        </div>
      )}

      {userItems.length > 0 && (
        <div className="flex flex-col gap-2">
          <SectionTitle title={t("Menu.account")} />
          {userItems.map((item) => (
            <MenuBannerCard key={item.key} item={item} isselected={activeKey === item.key} onClick={() => onClick(item.key)} />
          ))}
        </div>
      )}

      <div className="flex flex-col gap-2">
        <SectionTitle title={t("Menu.language")} />
        <LanguageSwitch className="flex w-full items-center gap-3 rounded-md px-4 py-2.5 text-sm font-semibold text-font-default hover:text-font-active transition-colors cursor-pointer" />
      </div>
    </div>
  );
};

export default ModulesMenuMob;
